'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentCreateInvoiceRequest(number, recipient, originOfGoods, manufacturer, documentaryCredit, currency, paymentTerms, usuance, placeOfReceipt, placeOfLoading, placeOfDelivery, placeOfDischarge, incoterm, vesselOrFlightNumber, lineItems, freightCost, insuranceNumber, insuranceCost, shipmentDate, importer, consignee, issueDate, dueDate, shippingMarks, purchaseOrderReference, harmonizedSystemCode, transportDocumentNumber, voyage, preCarriageVesselOrFlightNumber, measurements, containerNumber, truckNumber, paymentDetails) {
  this.a7C = null;
  this.a7M = null;
  this.a7D = null;
  this.a7A = null;
  this.a7q = null;
  this.a7p = null;
  this.a7F = null;
  this.a7R = null;
  this.a7J = null;
  this.a7I = null;
  this.a7G = null;
  this.a7H = null;
  this.a7v = null;
  this.a7S = null;
  this.a7z = null;
  this.a7s = null;
  this.a7x = null;
  this.a7w = null;
  this.a7N = null;
  this.a7u = null;
  this.a7n = null;
  this.a7y = null;
  this.a7r = null;
  this.a7O = null;
  this.a7L = null;
  this.a7t = null;
  this.a7P = null;
  this.a7T = null;
  this.a7K = null;
  this.a7B = null;
  this.a7o = null;
  this.a7Q = null;
  this.a7E = null;
  this.a7C = number;
  this.a7M = recipient;
  this.a7D = originOfGoods;
  this.a7A = manufacturer;
  this.a7q = documentaryCredit;
  this.a7p = currency;
  this.a7F = paymentTerms;
  this.a7R = usuance;
  this.a7J = placeOfReceipt;
  this.a7I = placeOfLoading;
  this.a7G = placeOfDelivery;
  this.a7H = placeOfDischarge;
  this.a7v = incoterm;
  this.a7S = vesselOrFlightNumber;
  this.a7z = lineItems;
  this.a7s = freightCost;
  this.a7x = insuranceNumber;
  this.a7w = insuranceCost;
  this.a7N = shipmentDate;
  this.a7u = importer;
  this.a7n = consignee;
  this.a7y = issueDate;
  this.a7r = dueDate;
  this.a7O = shippingMarks;
  this.a7L = purchaseOrderReference;
  this.a7t = harmonizedSystemCode;
  this.a7P = transportDocumentNumber;
  this.a7T = voyage;
  this.a7K = preCarriageVesselOrFlightNumber;
  this.a7B = measurements;
  this.a7o = containerNumber;
  this.a7Q = truckNumber;
  this.a7E = paymentDetails;
}
export { $c_Lapp_data_AppDocumentCreateInvoiceRequest as $c_Lapp_data_AppDocumentCreateInvoiceRequest };
$p = $c_Lapp_data_AppDocumentCreateInvoiceRequest.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentCreateInvoiceRequest;
/** @constructor */
function $h_Lapp_data_AppDocumentCreateInvoiceRequest() {
}
export { $h_Lapp_data_AppDocumentCreateInvoiceRequest as $h_Lapp_data_AppDocumentCreateInvoiceRequest };
$h_Lapp_data_AppDocumentCreateInvoiceRequest.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_AppDocumentCreateInvoiceRequest)) {
    if ((this.a7C === x$0.a7C)) {
      var x = this.a7M;
      var x$2 = x$0.a7M;
      var $x_31 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_31 = false;
    }
    if ($x_31) {
      var x$3 = this.a7D;
      var x$4 = x$0.a7D;
      var $x_30 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_30 = false;
    }
    if ($x_30) {
      var x$5 = this.a7A;
      var x$6 = x$0.a7A;
      var $x_29 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_29 = false;
    }
    if ($x_29) {
      var x$7 = this.a7q;
      var x$8 = x$0.a7q;
      var $x_28 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_28 = false;
    }
    if ($x_28) {
      var x$9 = this.a7p;
      var x$10 = x$0.a7p;
      var $x_27 = ((x$9 === null) ? (x$10 === null) : x$9.f(x$10));
    } else {
      var $x_27 = false;
    }
    if ($x_27) {
      var x$11 = this.a7F;
      var x$12 = x$0.a7F;
      var $x_26 = ((x$11 === null) ? (x$12 === null) : x$11.f(x$12));
    } else {
      var $x_26 = false;
    }
    if ($x_26) {
      var x$13 = this.a7R;
      var x$14 = x$0.a7R;
      var $x_25 = ((x$13 === null) ? (x$14 === null) : x$13.f(x$14));
    } else {
      var $x_25 = false;
    }
    if ($x_25) {
      var x$15 = this.a7J;
      var x$16 = x$0.a7J;
      var $x_24 = ((x$15 === null) ? (x$16 === null) : x$15.f(x$16));
    } else {
      var $x_24 = false;
    }
    if ($x_24) {
      var x$17 = this.a7I;
      var x$18 = x$0.a7I;
      var $x_23 = ((x$17 === null) ? (x$18 === null) : x$17.f(x$18));
    } else {
      var $x_23 = false;
    }
    if ($x_23) {
      var x$19 = this.a7G;
      var x$20 = x$0.a7G;
      var $x_22 = ((x$19 === null) ? (x$20 === null) : x$19.f(x$20));
    } else {
      var $x_22 = false;
    }
    if ($x_22) {
      var x$21 = this.a7H;
      var x$22 = x$0.a7H;
      var $x_21 = ((x$21 === null) ? (x$22 === null) : x$21.f(x$22));
    } else {
      var $x_21 = false;
    }
    if ($x_21) {
      var x$23 = this.a7v;
      var x$24 = x$0.a7v;
      var $x_20 = ((x$23 === null) ? (x$24 === null) : x$23.f(x$24));
    } else {
      var $x_20 = false;
    }
    if ($x_20) {
      var x$25 = this.a7S;
      var x$26 = x$0.a7S;
      var $x_19 = ((x$25 === null) ? (x$26 === null) : x$25.f(x$26));
    } else {
      var $x_19 = false;
    }
    if ($x_19) {
      var x$27 = this.a7z;
      var x$28 = x$0.a7z;
      var $x_18 = ((x$27 === null) ? (x$28 === null) : x$27.f(x$28));
    } else {
      var $x_18 = false;
    }
    if ($x_18) {
      var x$29 = this.a7s;
      var x$30 = x$0.a7s;
      var $x_17 = ((x$29 === null) ? (x$30 === null) : x$29.f(x$30));
    } else {
      var $x_17 = false;
    }
    if ($x_17) {
      var x$31 = this.a7x;
      var x$32 = x$0.a7x;
      var $x_16 = ((x$31 === null) ? (x$32 === null) : x$31.f(x$32));
    } else {
      var $x_16 = false;
    }
    if ($x_16) {
      var x$33 = this.a7w;
      var x$34 = x$0.a7w;
      var $x_15 = ((x$33 === null) ? (x$34 === null) : x$33.f(x$34));
    } else {
      var $x_15 = false;
    }
    if ($x_15) {
      var x$35 = this.a7N;
      var x$36 = x$0.a7N;
      var $x_14 = ((x$35 === null) ? (x$36 === null) : x$35.f(x$36));
    } else {
      var $x_14 = false;
    }
    if ($x_14) {
      var x$37 = this.a7u;
      var x$38 = x$0.a7u;
      var $x_13 = ((x$37 === null) ? (x$38 === null) : x$37.f(x$38));
    } else {
      var $x_13 = false;
    }
    if ($x_13) {
      var x$39 = this.a7n;
      var x$40 = x$0.a7n;
      var $x_12 = ((x$39 === null) ? (x$40 === null) : x$39.f(x$40));
    } else {
      var $x_12 = false;
    }
    if ($x_12) {
      var x$41 = this.a7y;
      var x$42 = x$0.a7y;
      var $x_11 = ((x$41 === null) ? (x$42 === null) : x$41.f(x$42));
    } else {
      var $x_11 = false;
    }
    if ($x_11) {
      var x$43 = this.a7r;
      var x$44 = x$0.a7r;
      var $x_10 = ((x$43 === null) ? (x$44 === null) : x$43.f(x$44));
    } else {
      var $x_10 = false;
    }
    if ($x_10) {
      var x$45 = this.a7O;
      var x$46 = x$0.a7O;
      var $x_9 = ((x$45 === null) ? (x$46 === null) : x$45.f(x$46));
    } else {
      var $x_9 = false;
    }
    if ($x_9) {
      var x$47 = this.a7L;
      var x$48 = x$0.a7L;
      var $x_8 = ((x$47 === null) ? (x$48 === null) : x$47.f(x$48));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$49 = this.a7t;
      var x$50 = x$0.a7t;
      var $x_7 = ((x$49 === null) ? (x$50 === null) : x$49.f(x$50));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$51 = this.a7P;
      var x$52 = x$0.a7P;
      var $x_6 = ((x$51 === null) ? (x$52 === null) : x$51.f(x$52));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$53 = this.a7T;
      var x$54 = x$0.a7T;
      var $x_5 = ((x$53 === null) ? (x$54 === null) : x$53.f(x$54));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$55 = this.a7K;
      var x$56 = x$0.a7K;
      var $x_4 = ((x$55 === null) ? (x$56 === null) : x$55.f(x$56));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$57 = this.a7B;
      var x$58 = x$0.a7B;
      var $x_3 = ((x$57 === null) ? (x$58 === null) : x$57.f(x$58));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$59 = this.a7o;
      var x$60 = x$0.a7o;
      var $x_2 = ((x$59 === null) ? (x$60 === null) : x$59.f(x$60));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$61 = this.a7Q;
      var x$62 = x$0.a7Q;
      var $x_1 = ((x$61 === null) ? (x$62 === null) : x$61.f(x$62));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$63 = this.a7E;
      var x$64 = x$0.a7E;
      return ((x$63 === null) ? (x$64 === null) : x$63.f(x$64));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 33;
});
$p.t = (function() {
  return "AppDocumentCreateInvoiceRequest";
});
$p.e = (function(n) {
  switch (n) {
    case 0: {
      return this.a7C;
      break;
    }
    case 1: {
      return this.a7M;
      break;
    }
    case 2: {
      return this.a7D;
      break;
    }
    case 3: {
      return this.a7A;
      break;
    }
    case 4: {
      return this.a7q;
      break;
    }
    case 5: {
      return this.a7p;
      break;
    }
    case 6: {
      return this.a7F;
      break;
    }
    case 7: {
      return this.a7R;
      break;
    }
    case 8: {
      return this.a7J;
      break;
    }
    case 9: {
      return this.a7I;
      break;
    }
    case 10: {
      return this.a7G;
      break;
    }
    case 11: {
      return this.a7H;
      break;
    }
    case 12: {
      return this.a7v;
      break;
    }
    case 13: {
      return this.a7S;
      break;
    }
    case 14: {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcats_data_NonEmptyVector(this.a7z);
      break;
    }
    case 15: {
      return this.a7s;
      break;
    }
    case 16: {
      return this.a7x;
      break;
    }
    case 17: {
      return this.a7w;
      break;
    }
    case 18: {
      return this.a7N;
      break;
    }
    case 19: {
      return this.a7u;
      break;
    }
    case 20: {
      return this.a7n;
      break;
    }
    case 21: {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDate(this.a7y);
      break;
    }
    case 22: {
      return this.a7r;
      break;
    }
    case 23: {
      return this.a7O;
      break;
    }
    case 24: {
      return this.a7L;
      break;
    }
    case 25: {
      return this.a7t;
      break;
    }
    case 26: {
      return this.a7P;
      break;
    }
    case 27: {
      return this.a7T;
      break;
    }
    case 28: {
      return this.a7K;
      break;
    }
    case 29: {
      return this.a7B;
      break;
    }
    case 30: {
      return this.a7o;
      break;
    }
    case 31: {
      return this.a7Q;
      break;
    }
    case 32: {
      return this.a7E;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.u = (function(n) {
  switch (n) {
    case 0: {
      return "number";
      break;
    }
    case 1: {
      return "recipient";
      break;
    }
    case 2: {
      return "originOfGoods";
      break;
    }
    case 3: {
      return "manufacturer";
      break;
    }
    case 4: {
      return "documentaryCredit";
      break;
    }
    case 5: {
      return "currency";
      break;
    }
    case 6: {
      return "paymentTerms";
      break;
    }
    case 7: {
      return "usuance";
      break;
    }
    case 8: {
      return "placeOfReceipt";
      break;
    }
    case 9: {
      return "placeOfLoading";
      break;
    }
    case 10: {
      return "placeOfDelivery";
      break;
    }
    case 11: {
      return "placeOfDischarge";
      break;
    }
    case 12: {
      return "incoterm";
      break;
    }
    case 13: {
      return "vesselOrFlightNumber";
      break;
    }
    case 14: {
      return "lineItems";
      break;
    }
    case 15: {
      return "freightCost";
      break;
    }
    case 16: {
      return "insuranceNumber";
      break;
    }
    case 17: {
      return "insuranceCost";
      break;
    }
    case 18: {
      return "shipmentDate";
      break;
    }
    case 19: {
      return "importer";
      break;
    }
    case 20: {
      return "consignee";
      break;
    }
    case 21: {
      return "issueDate";
      break;
    }
    case 22: {
      return "dueDate";
      break;
    }
    case 23: {
      return "shippingMarks";
      break;
    }
    case 24: {
      return "purchaseOrderReference";
      break;
    }
    case 25: {
      return "harmonizedSystemCode";
      break;
    }
    case 26: {
      return "transportDocumentNumber";
      break;
    }
    case 27: {
      return "voyage";
      break;
    }
    case 28: {
      return "preCarriageVesselOrFlightNumber";
      break;
    }
    case 29: {
      return "measurements";
      break;
    }
    case 30: {
      return "containerNumber";
      break;
    }
    case 31: {
      return "truckNumber";
      break;
    }
    case 32: {
      return "paymentDetails";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lapp_data_AppDocumentCreateInvoiceRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iE)));
}
export { $isArrayOf_Lapp_data_AppDocumentCreateInvoiceRequest as $isArrayOf_Lapp_data_AppDocumentCreateInvoiceRequest };
var $d_Lapp_data_AppDocumentCreateInvoiceRequest = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentCreateInvoiceRequest, "app.data.AppDocumentCreateInvoiceRequest", ({
  iE: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_AppDocumentCreateInvoiceRequest as $d_Lapp_data_AppDocumentCreateInvoiceRequest };
//# sourceMappingURL=app.data.-App-Document-Create-Invoice-Request.js.map
